import type { ThemeId } from './types'

/**
 * 문서가 선 뒤의 브라우저 UI 색. 값은 그 테마의 canvas와 같다.
 *
 * manifest에도 같은 성격의 값이 있지만 그쪽은 테마를 알기 전에 쓰이는 하나뿐이다. 문서가
 * 그려진 뒤로는 사용자가 고른 테마를 따라가야 해서 이 자리가 따로 있다.
 *
 * 첫 화면은 문서 머리의 스크립트가 세운다. 여기는 그 뒤의 전환만 맡는다.
 */
const CANVAS: Record<ThemeId, string> = {
  light: '#F8F5EF',
  dark: '#12161F',
  dusk: '#27212E',
}

export function applyBrowserUiColor(themeId: ThemeId): void {
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', CANVAS[themeId])
}
